import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from '../../core/services/authentication.service';
// import { SettingService } from 'src/app/core/services/setting.service';

import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Token } from '../../shared/models/token.model';
import { BehaviorSubject } from 'rxjs';
import { ModalControlService } from 'src/app/core/services/modal-control.service';
import { CartService } from 'src/app/core/services/productShared.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
	private apiUrl = environment.apiUrl;
	private apiUrl1 = environment.apiUrl1;
	loginForm: FormGroup;
	settings: any;
	isSettingsLoad: boolean;
	backgroundImage: string;
	isFormSubmitted = false;
	StepperPercentage: any;
	private currentTokenSubject: BehaviorSubject<Token>;
	userAccessToken: any;

	constructor(
		public translate: TranslateService,
		private router: Router,
		private formBuilder: FormBuilder,
		private toastr: ToastrService,
		private authenticationService: AuthenticationService,
		// private settingService: SettingService,
		private route: ActivatedRoute,
		private cookieService: CookieService,
		private modalControl: ModalControlService,
		private productsharedService: CartService
	) {
		this.userAccessToken = localStorage.getItem('token');
		this.currentTokenSubject = new BehaviorSubject<Token>(this.userAccessToken);
	}

	ngOnInit() {
		const token = this.route.snapshot.queryParamMap.get('token');
		if (token) {
			localStorage.setItem('access_token', token);
			localStorage.setItem('profile_status_percentage', token);
			this.router.navigate(['/dashboard']);
		} else {
			// Handle error or fallback
		}
		// this.getSettings();
		this.loadForm();
		this.modalControl.closeModal();
	}

	loadForm() {
		this.loginForm = this.formBuilder.group({
			email: ['', [Validators.required]],
			password: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(30)]]
		});
	}

	// getSettings() {
	// 	this.settingService.getSettings()
	// 		.subscribe(
	// 			data => {
	// 				this.settings = data;
	// 				this.setBGImage();
	// 				this.useDefaultLanguage();
	// 				this.isSettingsLoad = true;
	// 			});
	// }

	get userControl() { return this.loginForm.controls; }

	setBGImage() {
		if (this.settings && this.settings.login_background) {
			this.backgroundImage = this.apiUrl + '/uploads/login_bg/' + this.settings.login_background;
		} else {
			this.backgroundImage = 'assets/img/login-bg-2.png';
		}
	}

	useDefaultLanguage() {
		if (this.settings.default_language) {
			this.translate.use(this.settings.default_language);
		}
	}

	// onSubmit() {

	// 	this.isFormSubmitted = true;
	// 	if (this.loginForm.invalid) {
	// 		return;
	// 	}
	// 	this.authenticationService.login(this.userControl.email.value, this.userControl.password.value)
	// 		.subscribe(
	// 			(data: any) => {
	// 				// Check if the error exists in the response data
	// 				if (data && data.data && data.data.error) {
	// 					// If API returned an error in the response
	// 					this.toastr.error(data.data.error);
	// 				}
	// 				else {
	// 					localStorage.setItem('token', data.data.token);
	// 					localStorage.setItem('profile_status_percentage', data.data.profile_status_percentage);
	// 					const percentage = Number(data.data.profile_status_percentage) || 0;
	// 					this.productsharedService.setProgress(percentage);
	// 					localStorage.setItem('business_account_id', data.data.business_account_id || 0);
	// 					localStorage.setItem('business_account_name', data.data.business_account.businessName);
	// 					localStorage.setItem('business_account_slug', data.data.business_account.slugUrl);
	// 					this.currentTokenSubject.next(data.data.token);
	// 					this.router.navigate(['dashboard']);
	// 					this.toastr.success(this.translate.instant('Login successful'));
	// 				}

	// 			},
	// 			(err) => {
	// 				// Handle actual HTTP errors (network/server errors)
	// 				const errorMsg = err.error && err.error.data && err.error.data.error || err.error && err.error.message || this.translate.instant('Invalid credential');
	// 				this.toastr.error(errorMsg);
	// 			}
	// 		)
	// }

	onSubmit() {
		this.isFormSubmitted = true;
		if (this.loginForm.invalid) return;

		this.authenticationService.login(
			this.userControl.email.value,
			this.userControl.password.value
		).subscribe(
			(res: any) => {

				if (!res || !res.data) {
					this.toastr.error('Something went wrong');
					return;
				}

				const data = res.data; // shorter access

				// Save token always
				if (data.token) {
					localStorage.setItem('token', data.token);
				}

				// Save progress
				const progress = data.profile_status_percentage ? Number(data.profile_status_percentage) : 0;
				localStorage.setItem('profile_status_percentage', progress.toString());
				this.productsharedService.setProgress(progress);

				// Business Account Exists
				if (data.business_account) {
					const ba = data.business_account;
					localStorage.setItem('business_account_name', ba.businessName ? ba.businessName : '');
					localStorage.setItem('business_account_slug', ba.slugUrl ? ba.slugUrl : '');
					localStorage.setItem('business_account_id', data.business_account_id ? data.business_account_id : '');
				}
				// No Business Account
				else {
					localStorage.removeItem('business_account_name');
					localStorage.removeItem('business_account_slug');
					localStorage.removeItem('business_account_id');
				}

				// 🚀 Common redirect
				this.toastr.success('Login successful');
				this.router.navigate(['/dashboard']);
			},
			(err) => {
				let msg = 'Invalid credentials';
				if (err && err.error) {
					if (err.error.data && err.error.data.error) msg = err.error.data.error;
					else if (err.error.message) msg = err.error.message;
				}
				this.toastr.error(msg);
			}
		);
	}


	instantLogin(email, password) {
		this.loginForm.patchValue({ email: email });
		this.loginForm.patchValue({ password: password });
	}

	continueGoogle() {
		window.location.href = this.apiUrl1 + '/oauth2/authorization/google';
	}

	showPassword = false;

	togglePassword() {
		this.showPassword = !this.showPassword;
	}


}